import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { loadById } from '../../actions/lessons';
import { isLocal, domain } from '../../config';

import Contents from './Contents';

const mapStateToProps = ({ user, lessons }, { match }) => ({
  permissions: user.permissions || [],
  details: lessons.details[+match.params.id],
  options: user.options || [],
  allow_chat: user.options && user.options.allow_chat,
  hide_links_on_learning: user.options && user.options.hide_links_on_learning,
  all_in_one_tab: user.options && user.options.all_in_one_tab,
  new_question_new_tab: user.options && user.options.new_question_new_tab,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadById,
    },
    dispatch,
  );

class LessonDetails extends React.Component {
  componentDidMount() {
    const { match } = this.props;
    this.id = +match.params.id;
    this.trainingId = +match.params.tid;
    this.props.loadById(this.id);
  }

  render() {
    const { details, permissions, options, allow_chat, hide_links_on_learning, all_in_one_tab, new_question_new_tab } = this.props;
    if (!details || !permissions.includes('LESSON_DETAILS')) {
      return null;
    }

    const {
      audios,
      documents,
      links,
      texts,
      videos,
      images,
      notes: my_notes,
      pictures: my_pictures,
      questions,
      replies,
    } = details;

    const path = isLocal ? '//localhost:3002/#' : `${domain}/company/#`;

    return (
      <div>
        {!hide_links_on_learning &&
          <div className="category_block">
            <ul>
              {allow_chat && (
                <li className="category">
                  <Link to="/trainings/chats" target={all_in_one_tab ? "_self" : "_blank"}>
                    <i className="icon_c icon_c_bg icon_chats" />
                    <FormattedMessage id="routes_chats" />
                  </Link>
                </li>
              )}
              <li className="category">
                {/* <a href={`${path}/reports/users`} target={all_in_one_tab ? "_self" : "_blank"} rel="noreferrer">
                <i className="icon_c icon_c_bg icon_reports" />
                <FormattedMessage id="routes_reports" />
              </a> */}
                <Link to={`/trainings/mytrainings/${this.trainingId}/lessons/${this.id}/notes`} target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_notes" />
                  <FormattedMessage id="routes_notes" />
                </Link>
              </li>
              <li className="category">
                <Link to={`/trainings/mytrainings/${this.trainingId}/lessons/${this.id}/pictures`} target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_images" />
                  <FormattedMessage id="routes_pictures" />
                </Link>
              </li>
              <li className="category">
                <Link to={`/trainings/mytrainings/${this.trainingId}/lessons/${this.id}/results`} target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_reports" />
                  <FormattedMessage id="lessons_details_statistics" />
                </Link>
              </li>
              <li className="category">
                <Link to="/trainings/certificates" target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_cert" />
                  <FormattedMessage id="routes_certificates" />
                </Link>
              </li>
            </ul>
          </div>
        }
        {this.id ? (
          <Contents id={this.id} key="Contents" />
        ) : ''}
        <div className="category_block">
          <ul>
            <li className="category c">
              <Link
                to={`/trainings/mytrainings/${this.trainingId}/lessons/${this.id
                  }/${replies == questions ? 'results' : 'passing'}`}
                target={new_question_new_tab && !all_in_one_tab ? "_blank" : "_self"}
              >
                <i className="icon_c icon_c_bg icon_questions" />
                <FormattedMessage
                  id="lessons_details_questions"
                  values={{ replies, questions }}
                />
              </Link>
            </li>
          </ul>
        </div>
        <div className="clear10" />
      </div>
    );
  }
}

LessonDetails.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  loadById: PropTypes.func.isRequired,
  details: PropTypes.objectOf(PropTypes.any),
  match: PropTypes.objectOf(PropTypes.any),
  allow_chat: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(LessonDetails);



// WEBPACK FOOTER //
// ./src/views/_Lessons/Details.js